import * as React from "react";
import { SVGProps } from "react";
const SvgComponent = ({ fill, ...props }: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <path
      fill={fill || "currentColor"}
      fillRule="evenodd"
      d="M16.362 5.368A8 8 0 0 0 4.198 9.795a1 1 0 1 1-1.922-.551A10 10 0 0 1 20.694 7.26l.363-.67a1 1 0 0 1 1.758.952L21.58 9.825a1 1 0 0 1-.733.513l-2.567.381a1 1 0 0 1-.293-1.978l1.13-.168a8 8 0 0 0-2.755-3.205Zm-9.659 9.42a1 1 0 0 1-.842 1.136l-.87.13a8 8 0 0 0 14.268-.944 1 1 0 0 1 1.843.777 10 10 0 0 1-17.799 1.24l-.512.947a1 1 0 0 1-1.759-.953l1.236-2.282A1 1 0 0 1 3 14.326l2.567-.38a1 1 0 0 1 1.136.842Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgComponent;
